<script setup>
import SimpleRadioGroupOptions from "../../Components/Form/SimpleRadioGroupOptions";
import {ref} from "vue";

const emit = defineEmits(['update:modelValue']);

const props = defineProps({
    'modelValue': Boolean,
    'containerClasses': String,
})

const options = [
    {type: true, name: 'Yes'},
    {type: false, name: 'No'},
];

const selectedOption = ref();

const setSelectedOption = (option) => {
    let originalObject = options.filter(elm => elm.type == option);

    if (originalObject.length < 1)
        return;

    selectedOption.value = originalObject[0];
}

const updatedModelValue = (modelValue) => {
    setSelectedOption(modelValue.type);
    emit('update:modelValue', modelValue.type);
}

setSelectedOption(props.modelValue);

</script>
<template>
    <SimpleRadioGroupOptions :options="options"
                             :container-classes="containerClasses"
                             :model-value="selectedOption" @update:modelValue="updatedModelValue"></SimpleRadioGroupOptions>
</template>